import React, { useState } from 'react';

/**
 * Copie `value` dans le presse-papiers. navigator.clipboard n'existe qu'en contexte
 * sécurisé (https / localhost) : repli sur un textarea temporaire + execCommand('copy').
 */
export async function copyText(value) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const area = document.createElement('textarea');
  area.value = value;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  document.execCommand('copy');
  document.body.removeChild(area);
}

/**
 * Bouton-icône de copie : libellé au survol (title), ✔ pendant 1,5 s après la copie.
 * Apparence et survol : classes .ui-copy (ui.css).
 */
export default function CopyButton({ value, title }) {
  const [copied, setCopied] = useState(false);
  const label = copied ? 'Copié ✔' : (title || `Copier « ${value} »`);
  const copy = async e => {
    e.stopPropagation();
    try {
      await copyText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // presse-papiers refusé : rien de plus à faire, la valeur reste affichée
    }
  };
  return (
    <button type="button" onClick={copy} title={label} aria-label={label}
            className={copied ? 'ui-copy ui-copy--done' : 'ui-copy'}>
      {copied ? '✔' : '⧉'}
    </button>
  );
}
